import { TextArea as BaseTextArea } from '@kvdbil/components';
import { TextAreaProps as BaseTextAreaProps } from '@kvdbil/components/types/components/TextArea';
import React, { RefObject } from 'react';
import {
  Control,
  Controller,
  FieldValues,
  Path,
  PathValue
} from 'react-hook-form';
import { ControllerRules } from '~/App/shared/interfaces/ControllerRules';

type TextFieldProps<FormState extends FieldValues> = Omit<
  BaseTextAreaProps,
  'value'
> & {
  control: Control<FormState>;
  name: Path<FormState>;
  rules?: ControllerRules;
  defaultValue?: PathValue<FormState, Path<FormState>>;
};

const Input = React.forwardRef((props: BaseTextAreaProps, ref) => (
  <BaseTextArea {...props} forwardRef={ref as RefObject<HTMLInputElement>} />
));

const TextAreaWithControl = <FormState extends FieldValues>(
  props: TextFieldProps<FormState>
) => {
  return (
    <Controller<FormState>
      {...props}
      render={({ field, fieldState }) => {
        return (
          <Input
            {...props}
            {...field}
            value={field.value}
            errors={[fieldState.error?.message ?? '']}
            hasError={Boolean(fieldState.error)}
          />
        );
      }}
    />
  );
};

export default TextAreaWithControl;
